import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import React, { AnchorHTMLAttributes, FC, PropsWithChildren } from 'react';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  id?: string
}

const Link: FC<PropsWithChildren<LinkProps & NextLinkProps>> = (props) => {
  return <NextLink id={props.id} {...props} />;
};

export default Link;
